/**
 * @generated SignedSource<<9f6362bdef976f1891cc85a14210cfed>>
 * @relayHash e4c493ec197fdfb6eb597c1e5cc6c430
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec5d148a6bf1b0bbf739ad3280e032c82fd08256cc50a97dc2063f7726739d5e

import type { ConcreteRequest } from 'relay-runtime';
export type ContentRepresentation = "ATLAS_DOC_FORMAT" | "EDITOR" | "EDITOR2" | "EXPORT_VIEW" | "PLAIN" | "RAW" | "STORAGE" | "STYLED_VIEW" | "VIEW" | "WIKI" | "%future added value";
export type Platform = "ANDROID" | "IOS" | "WEB" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type CreateCommentInput = {
  commentBody: CommentBody;
  commentSource?: Platform | null;
  containerId: string;
  parentCommentId?: string | null;
};
export type CommentBody = {
  representationFormat: ContentRepresentation;
  value: string;
};
export type useCreateObjectCommentMutation$variables = {
  cloudId: string;
  includeReactionsSummary: boolean;
  input: CreateCommentInput;
  pageId: string;
};
export type useCreateObjectCommentMutation$data = {
  readonly createFooterComment: {
    readonly author: {
      readonly __typename: string;
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly permissionType: SitePermissionType | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    };
    readonly body: {
      readonly value: string;
    };
    readonly container: {
      readonly id: string | null;
    };
    readonly contentStatus: string;
    readonly createdAt: {
      readonly value: string;
    };
    readonly createdAtNonLocalized: string;
    readonly id: string;
    readonly links: {
      readonly editui: string | null;
      readonly webui: string | null;
    };
    readonly location: {
      readonly __typename: string;
      readonly commentResolveProperties?: {
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null;
        readonly resolvedTime: AGG$Long | null;
        readonly resolvedUser: string | null;
      } | null;
      readonly inlineMarkerRef?: string | null;
      readonly inlineResolveProperties?: {
        readonly isDangling: boolean;
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null;
        readonly resolvedTime: AGG$Long | null;
        readonly resolvedUser: string | null;
      } | null;
      readonly inlineText?: string | null;
      readonly type: string;
    };
    readonly parentId: string | null;
    readonly permissions: {
      readonly isEditable: boolean;
      readonly isRemovable: boolean;
      readonly isResolvable: boolean;
    };
    readonly reactionsSummary?: {
      readonly ari: string;
      readonly containerAri: string;
      readonly reactionsCount: number;
      readonly reactionsSummaryForEmoji: ReadonlyArray<{
        readonly count: number;
        readonly emojiId: string;
        readonly id: string;
        readonly reacted: boolean;
      } | null>;
    } | null;
    readonly version: {
      readonly by: {
        readonly __typename: string;
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly type: string | null;
      } | null;
      readonly friendlyWhen: string | null;
      readonly number: number | null;
      readonly when: string | null;
    };
  } | null;
};
export type useCreateObjectCommentMutation = {
  response: useCreateObjectCommentMutation$data;
  variables: useCreateObjectCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeReactionsSummary"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v9 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v11 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v12 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v13 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v14 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Comment",
    "kind": "LinkedField",
    "name": "createFooterComment",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "permissionType"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "profilePicture",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ]
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "representation",
            "value": "ATLAS_DOC_FORMAT"
          }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": (v9/*: any*/),
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "contentStatus"
      },
      {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": (v9/*: any*/)
      },
      {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
      },
      {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "editui"
          },
          {
            "kind": "ScalarField",
            "name": "webui"
          }
        ]
      },
      {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ]
              }
            ],
            "type": "FooterComment"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
              },
              {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isDangling"
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "inlineText"
              }
            ],
            "type": "InlineComment"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "parentId"
      },
      {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEditable"
          },
          {
            "kind": "ScalarField",
            "name": "isRemovable"
          },
          {
            "kind": "ScalarField",
            "name": "isResolvable"
          }
        ]
      },
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "friendlyWhen"
          },
          {
            "kind": "ScalarField",
            "name": "number"
          },
          {
            "kind": "ScalarField",
            "name": "when"
          }
        ]
      },
      {
        "condition": "includeReactionsSummary",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
              },
              {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
              },
              {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "pageId"
              }
            ],
            "concreteType": "ReactionsSummaryResponse",
            "kind": "LinkedField",
            "name": "reactionsSummary",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "ari"
              },
              {
                "kind": "ScalarField",
                "name": "containerAri"
              },
              {
                "kind": "ScalarField",
                "name": "reactionsCount"
              },
              {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "count"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "emojiId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "reacted"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCreateObjectCommentMutation",
    "selections": (v14/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCreateObjectCommentMutation",
    "selections": (v14/*: any*/)
  },
  "params": {
    "cacheID": "e4c493ec197fdfb6eb597c1e5cc6c430",
    "id": "ec5d148a6bf1b0bbf739ad3280e032c82fd08256cc50a97dc2063f7726739d5e",
    "metadata": {},
    "name": "useCreateObjectCommentMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateObjectCommentMutation($pageId:ID!,$cloudId:ID!,$input:CreateCommentInput!,$includeReactionsSummary:Boolean!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsSummary){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
  }
};
})();

(node as any).hash = "c1ecd7a7f6b08a2552cfea3da74fecee";

export default node;
